<template>
  <div class="accessibility">
    <HeaderComponent screenName="" />
    <ContractVehiclesBannerComponent
      imageSrc="contracts-banner.jpg"
      heading="Accessibility"
    />
    <div class="section-div" data-aos="fade-up">
     <div class="cards-container">   
      <div class="card" data-aos="fade-up">
        <p class="subheading">Accessibility Information</p>
        <p>
          G14C strives to make its products and services accessible for all users, including people with disabilities. Our corporate website, www.G14C.net, complies with best practices and standards as defined by Section 508 of the U.S. Rehabilitation Act and the Web Content Accessibility Guidelines (WCAG) of the World Wide Web Consortium Web Accessibility Initiative (W3C WAI).<br><br>

          At G14C, we routinely develop Section 508- compliant deliverables that meet not only the letter of the law, but the spirit of the law. We possess mature methods, apply best practices, and employ innovative strategies that ensure all users have friendly access to all information and enjoy the same or similar experience. Our staff is well-qualified in designing, developing, and testing for Section 508 compliance. We are sensitive to the needs and requirements of users with disabilities, including varying levels of visual disabilities, motor disabilities, and even cognitive challenges.<br><br>
        </p>
        <p class="subheading">G14C’s Product and Solutions Accessibility</p>
        <p>
        To assist Federal contracting officials and other buyers in making preliminary assessments regarding the availability of commercial "Electronic and Information Technology" products and services with features that support accessibility, G14C has provided the following information and contact details.<br><br>  
        </p>
         
        <p>G14C understands the emphasis on—and need for—accessible systems and tools. Our comprehensive approach to Section 508 compliance includes the following:</p><br>
       
        <ul>
         <li><b>Analysis:</b> We review any Section 508-related government-provided information, checklists, agency-specific requirements, and preferences. We determine the product type (e.g., website, training, document, system, or tool), examine the target audience, examine the overall project requirements, and use a 508 survey to identify any areas of concern needing special focus to meeting compliance. If necessary, we work with the government to address any issues at a high level, via status reports, regular status meetings, or special meetings. 
        </li>
        <li>
         <b>Design:</b> We design with 508 in mind. As a standard part of our deliverable design phase, we identify safe color pallets, choose accessible font style and size, and design user-friendly, appealing, yet compliant style sheets. We determine the needed level and style for alt tags (very detailed vs. minimal identification), as well as the need for long descriptions. We design logical page navigation, skip links, and tabbing, for example. In the event that alternatives are needed to meet Section 508 compliance that can’t be handled with standard means (e.g., complex interactive element), we thoroughly review proposed strategies with our customers and obtain government approval prior to development. We also refine 508 checklists and test plans to be used during development and testing. 
        </li>
        <li>
        <b>Development and Testing:</b> We develop and test for 508 compliance as a part of each sprint. As we develop, we use Freedom Scientific’s JAWS to ensure readability of all elements (e.g., content, form fields, graphics, interactive elements (buttons); tab through the entire deliverable to ensure logical navigation and access to every element; we use the Web Accessibility Toolbar (WAT) to test for a variety accessibility elements (color, font, etc.). 
        </li>
        <li>
        <b>VPAT:</b> For many government clients we complete the Voluntary Product Accessibility Template (VPAT), to assist our customers in assessing or planning our deliverable’s compliance with Section 508 requirements.
        </li>
        </ul>
      </div>
    </div>
    </div>
    <FooterComponent />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

// Components
import HeaderComponent from '@/components/HeaderComponent.vue';
import ContractVehiclesBannerComponent from '@/components/contract vehicles/ContractVehiclesBannerComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';

export default defineComponent({
  components: {
    HeaderComponent,
    ContractVehiclesBannerComponent,
    FooterComponent,
  },
});
</script>

<style scoped>


.section-div {
  background-color: #f2f2f2;
  padding-left: 110px;
  padding-right: 110px;
  padding-top: 100px;
  padding-bottom: 50px;
}

.cards-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 55px; 
}

.card {
  background-color: #fff;
  padding: 50px;
  width: 85%; 
  height: auto;
  text-align: left;
  font-family: Roboto;
  box-shadow:  0 8px 16px rgba(0, 0, 0, 0.2); 
  font-size: 20px; 
}
.subheading
{
  text-align: center;
  font-family: Roboto;
  font-size:23px;
  font-weight: 400;
}


.card ul {
  margin-left: 20px;
}

</style>
